import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import backupHero from "../assets/Hero/backup-image.jpg"; // Replace with your hero image
import backupImage from "../assets/Hero/backup-and-disaster-recovery.png"; // Replace with your backup image
import "../assets/css/backupRecoveryPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const backupData = {
  hero: {
    title: "Backup & Recovery Solutions",
    subtitle: "Protecting Your Data, Ensuring Business Continuity",
  },
  introduction: {
    heading: "Why Backup & Recovery Matters",
    paragraphs: [
      "In today's digital world, data is the lifeblood of your business. Loss of critical data can lead to downtime, financial losses, and reputational damage.",
      "Our Backup & Recovery solutions ensure your data is securely stored and easily recoverable, minimizing risks and keeping your business running smoothly.",
    ],
  },
  features: {
    heading: "Our Backup & Recovery Features",
    items: [
      "Automated Daily Backups",
      "Secure Cloud Storage",
      "Fast Data Recovery",
      "End-to-End Encryption",
      "24/7 Monitoring & Support",
      "Disaster Recovery Planning",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    paragraphs: [
      "Minimize downtime and ensure business continuity with reliable backup systems.",
      "Protect sensitive data with advanced encryption and security protocols.",
      "Scale your storage needs as your business grows.",
      "Gain peace of mind knowing your data is safe and recoverable.",
    ],
  },
  cta: {
    heading: "Ready to Secure Your Data?",
    text: "Contact us today to learn more about our Backup & Recovery solutions and how we can help protect your business.",
  },
};

export const BackupRecoveryPage = ({ data }) => {
  const backupRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = backupRef.current.querySelectorAll(".backup-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: backupRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="backup-page" ref={backupRef}>
      {/* Hero Section */}
      <div
        className="backup-hero-section"
        style={{ backgroundImage: `url(${backupHero})` }}
      >
        <h1 className="backup-animate">{backupData.hero.title}</h1>
        <p className="backup-animate">{backupData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container backup-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="backup-animate">{backupData.introduction.heading}</h2>
            {backupData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="backup-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 backup-image-container">
            <img
              src={backupImage}
              className="img-fluid backup-animate"
              alt="Backup & Recovery"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container backup-features">
        <h2 className="backup-animate">{backupData.features.heading}</h2>
        <ul>
          {backupData.features.items.map((item, index) => (
            <li key={index} className="backup-animate">
              {item}
            </li>
          ))}
        </ul>
      </div>

      {/* Benefits Section */}
      <div className="container backup-benefits">
        <h2 className="backup-animate">{backupData.benefits.heading}</h2>
        {backupData.benefits.paragraphs.map((paragraph, index) => (
          <p key={index} className="backup-animate">
            {paragraph}
          </p>
        ))}
      </div>

      {/* Call to Action Section */}
      {/* <div className="container backup-cta">
        <h2 className="backup-animate">{backupData.cta.heading}</h2>
        <p className="backup-animate">{backupData.cta.text}</p>
        <button
          className="btn btn-primary backup-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};